import { Moon, Sun } from 'lucide-react';
import { useTheme, Theme } from '@/contexts/ThemeContext';
import { SegmentedTabs } from './SegmentedTabs';

export interface ThemeToggleProps {
  size?: 'sm' | 'md';
  fullWidth?: boolean;
  className?: string;
}

/**
 * Przełącznik motywu ciemny/jasny. Używa globalnego ThemeContextu —
 * zmiana od razu aplikuje klasę na <html> i zapisuje preferencję.
 */
export function ThemeToggle({ size = 'sm', fullWidth = false, className }: ThemeToggleProps) {
  const { theme, setTheme } = useTheme();
  return (
    <SegmentedTabs<Theme>
      aria-label="Motyw interfejsu"
      size={size}
      fullWidth={fullWidth}
      className={className}
      value={theme}
      onChange={setTheme}
      options={[
        { value: 'dark', label: 'Ciemny', icon: Moon },
        { value: 'light', label: 'Jasny', icon: Sun },
      ]}
    />
  );
}
